import React from "react";

const ScorecardSkeleton: React.FC = () => {
    return (
        <div className="flex flex-row animate-pulse">
            <div className="flex flex-1 flex-col md:flex-row">
                <div className="flex flex-1 flex-row justify-between pb-8">
                    {Array.from({ length: 9 }).map((_, i) => (
                        <div key={`skel_front_${i}`} className="flex flex-col items-center mx-0.5">
                            <div className="w-5 h-5 rounded-full bg-gray-200 mb-2" />
                            <div className="w-6 h-4 rounded bg-gray-200 mb-2" />
                            <div className="w-6 h-5 rounded bg-gray-200" />
                        </div>
                    ))}
                    <div className="flex flex-col items-center mx-1">
                        <div className="w-10 h-6 rounded-full bg-gray-200 mb-2" />
                        <div className="w-6 h-4 rounded bg-gray-200 mb-2" />
                        <div className="w-6 h-5 rounded bg-gray-200" />
                    </div>
                    <div className="w-10" />
                </div>
                <div className="flex flex-1 flex-row justify-between">
                    {Array.from({ length: 9 }).map((_, i) => (
                        <div key={`skel_back_${i}`} className="flex flex-col items-center mx-0.5">
                            <div className="w-5 h-5 rounded-full bg-gray-200 mb-2" />
                            <div className="w-6 h-4 rounded bg-gray-200 mb-2" />
                            <div className="w-6 h-5 rounded bg-gray-200" />
                        </div>
                    ))}
                    <div className="flex flex-col items-center mx-1">
                        <div className="w-10 h-6 rounded-full bg-gray-200 mb-2" />
                        <div className="w-6 h-4 rounded bg-gray-200 mb-2" />
                        <div className="w-6 h-5 rounded bg-gray-200" />
                    </div>
                    <div className="flex flex-col items-center mx-1">
                        <div className="w-10 h-6 rounded-full bg-gray-200 mb-2" />
                        <div className="w-6 h-4 rounded bg-gray-200 mb-2" />
                        <div className="w-6 h-5 rounded bg-gray-200" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ScorecardSkeleton; 